// extracted by mini-css-extract-plugin
export var smallSpinner = "_wt-0";